import api from "../api/Client";

export type ProfessionalLeaveType = {
  id: number;
  title: string;
};

export type ProfessionalHoliday = {
  holiday_id: number;
  holiday_name: string;
  date: string;
  created_at: string | null;
};

export type ProfessionalLeave = {
  leave_id: number;
  coach_id: number;
  title: string;
  start_date: string;
  end_date: string;
  start_time: string | null;
  end_time: string | null;
  not_available_this_day: number;
  is_leave_approve: number | null;
  is_leave_denied: number;
  type_id: number | null;
  type_name: string;
  created_at: string | null;
};

export async function fetchProfessionalLeaveTypes() {
  const response = await api.get("/api/professionals/leave-types");
  return (Array.isArray(response.data) ? response.data : []) as ProfessionalLeaveType[];
}

export async function fetchProfessionalHolidays() {
  const response = await api.get("/api/professionals/holidays", {
    params: { future: 1 }
  });
  return (Array.isArray(response.data) ? response.data : []) as ProfessionalHoliday[];
}

export async function fetchProfessionalLeaves() {
  const response = await api.get("/api/professionals/leaves", {
    params: { future: 1 }
  });
  return (Array.isArray(response.data) ? response.data : []) as ProfessionalLeave[];
}

export async function createProfessionalLeave(payload: {
  title: string;
  type_id: number;
  start_date: string;
  end_date: string;
  not_available_this_day: number;
  start_time?: string;
  end_time?: string;
}) {
  await api.post("/api/professionals/leaves", payload);
}

export async function deleteProfessionalLeave(leaveId: number) {
  await api.delete(`/api/professionals/leaves/${leaveId}`);
}
